package com.flowyride.data.account.internal

import com.flowyride.core.api.ApiErrorDto
import com.flowyride.core.api.toAccountException
import com.flowyride.core.domain.account.AccountException
import com.flowyride.core.network.NetworkJson
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.http.isSuccess
import kotlin.coroutines.cancellation.CancellationException

/** Normalises any failure of a server call into an [AccountException]. */
internal inline fun <T> accountCall(block: () -> T): T =
    try {
        block()
    } catch (e: CancellationException) {
        throw e
    } catch (e: AccountException) {
        throw e
    } catch (e: Throwable) {
        // Throwable: on the web, Ktor reports network failures as kotlin.Error ("Fail to fetch").
        throw AccountException.Unreachable(e)
    }

/** @throws AccountException decoded from the server's error body. */
internal suspend fun HttpResponse.ensureSuccess(): HttpResponse {
    if (status.isSuccess()) return this
    val error = runCatching { NetworkJson.decodeFromString<ApiErrorDto>(bodyAsText()) }.getOrNull()
    throw error?.toAccountException() ?: AccountException.Unreachable(IllegalStateException("HTTP ${status.value}"))
}
